import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './DashboardVos.scss';

interface FullDashboardVosImageProps {
    onClickShow: () => void;
    onClickHide: () => void;
    show: boolean;
    image: string;
    imageName: string;
}

const FullVosImage = ({ onClickHide, show, image, imageName }: FullDashboardVosImageProps): React.ReactElement => {
    return (
        <Modal size="lg" show={show} onHide={onClickHide}>
            <Modal.Header closeButton>
                <Modal.Title>{imageName}</Modal.Title>
            </Modal.Header>
            <img className="VosImage-Full" src={image} onClick={onClickHide} alt="" />
        </Modal>
    );
};

export default FullVosImage;

